module.exports = function getResource(label, vars=[]) {
    const resources = {
        bopisTitle: `Buy Online and Pick Up (${vars[0]})`,
        shippingTitle: `Shipping and Delivery Basket (${vars[0]})`,
        basketSwitchBOPIS: 'View your Buy Online and Pick Up Basket',
        basketSwitchShipping: 'View your Shipping and Delivery Basket'
    };

    return resources[label];
};
